import * as React from 'react'
import { cn } from '../../lib/utils'

const Table = ({ className, ...props }) => (
  <div className="relative w-full overflow-x-auto">
    <table className={cn('w-full caption-bottom text-sm', className)} {...props} />
  </div>
)
const TableHeader = ({ className, ...props }) => (
  <thead className={cn('[&_tr]:border-b', className)} {...props} />
)
const TableBody = ({ className, ...props }) => (
  <tbody className={cn('[&_tr:last-child]:border-0', className)} {...props} />
)
const TableRow = ({ className, ...props }) => (
  <tr className={cn('border-b border-border transition-colors hover:bg-muted/40', className)} {...props} />
)
const TableHead = ({ className, ...props }) => (
  <th className={cn('h-9 px-3 text-left align-middle text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground', className)} {...props} />
)
const TableCell = ({ className, ...props }) => (
  <td className={cn('px-3 py-2 align-middle text-[13px]', className)} {...props} />
)

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell }
